import { useEffect } from "react";
import { useApolloClient } from "@apollo/client";

export const useLocalSubscription = (query, options) => {
  const { onSubscriptionData, variables } = options;
  const client = useApolloClient();

  const observer = client.subscribe({
    query,
    variables
  });

  const subscription = observer.subscribe(event => {
    onSubscriptionData && onSubscriptionData(event);
  });

  useEffect(() => {
    return () => {
      subscription.unsubscribe();
    };
  }, [subscription]);
};
